import type { SearchCalendarSummaryFunctionCalendarSummaryFragment } from './search.generated'

export type SearchCondition = {
  searchTexts?: string[]
}

export const createSearchConditionByQuery = (
  searchQuery: string
): SearchCondition => {
  if (!searchQuery) {
    return {}
  }
  return {
    searchTexts: searchQuery.split(/\s+/).filter(text => text.trim() !== ''),
  }
}

const normalizeSearchText = (text: string | null | undefined): string => {
  return text?.toLocaleLowerCase().trim() ?? ''
}

export const searchCalendarSummary = <
  T extends SearchCalendarSummaryFunctionCalendarSummaryFragment,
>(
  condition: SearchCondition,
  target: T[]
): T[] => {
  if (!condition.searchTexts || condition.searchTexts.length === 0) {
    return target
  }

  const searchTextsLower = condition.searchTexts.map(text =>
    normalizeSearchText(text)
  )

  return target.filter(item => {
    const description = normalizeSearchText(item.description)
    const privateTitle = normalizeSearchText(item.privateTitle)
    const publicTitle = normalizeSearchText(item.publicTitle)
    const assignedStaffDisplayNames = item.assignedStaffs.map(staff =>
      normalizeSearchText(staff.displayName)
    )

    const targetTexts = [
      description,
      privateTitle,
      publicTitle,
      ...assignedStaffDisplayNames,
    ]

    return searchTextsLower.every(searchText =>
      targetTexts.some(targetText => targetText.includes(searchText))
    )
  })
}
